import { Component, input } from '@angular/core';
import { NavigationButton } from '../../navigation-button/navigation-button';
import { provideIcons } from '@ng-icons/core';
import {
  tablerBriefcase,
  tablerLayoutGrid,
  tablerFolder,
  tablerStack2,
} from '@ng-icons/tabler-icons';

@Component({
  selector: 'navigation-links',
  template: `
    <div class="navigation-links" [class.collapsed]="isCollapsed()">
      <navigation-button
        href="/home"
        label="Discover"
        icon="tablerLayoutGrid"
        [showIconOnly]="isCollapsed()"
      />
      <navigation-button
        href="/catalog"
        label="Asset Catalog"
        icon="tablerBriefcase"
        [showIconOnly]="isCollapsed()"
      />
      <navigation-button
        disabled
        href="/#"
        label="Workspaces"
        badge="Coming soon"
        icon="tablerStack2"
        [showIconOnly]="isCollapsed()"
      />
      <navigation-button
        disabled
        href="/#"
        label="My Library"
        badge="Coming soon"
        icon="tablerFolder"
        [showIconOnly]="isCollapsed()"
      />
    </div>
  `,
  styles: `
    div.navigation-links {
      padding: 2px 10px 6px;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 2px;

      &.collapsed {
        padding: 0 0 6px;
      }
    }
  `,
  imports: [NavigationButton],
  providers: [
    provideIcons({
      tablerLayoutGrid,
      tablerBriefcase,
      tablerFolder,
      tablerStack2,
    }),
  ],
})
export class NavigationLinks {
  readonly isCollapsed = input.required<boolean>();
}
